import React from "react";

interface EmailSentConfirmationProps {
  mpName: string;
  userEmail: string;
}

const EmailSentConfirmation: React.FC<EmailSentConfirmationProps> = ({
  mpName,
}) => {
  return (
    <div className="font-light text-center">
      <h4 className="text-base mt-4 mb-6 font-bold">
        Thank you, your message is on its way to {mpName}.
      </h4>
      <p className="text-base font-bold mb-4">
        Ready for more? Help us drive change further.
      </p>
      <a
        href="https://www.evaengland.org.uk/join-now/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="mb-6 bg-[#00b3bd] text-white font-bold py-2 px-4 rounded uppercase">
          Get Involved
        </button>
      </a>
      <div>
        <button
          onClick={() => (window.location.href = "/")}
          className="bg-gray-400 hover:bg-gray-500 text-white font-bold py-2 px-4 rounded uppercase"
        >
          Back to Homepage
        </button>
      </div>
    </div>
  );
};

export default EmailSentConfirmation;
